export enum InsuranceServiceName {
  RECHTSBERATUNG = 'RECHTSBERATUNG',
  MIETRECHTSSCHUTZ = 'MIETRECHTSSCHUTZ',
  MEDIATION = 'MEDIATION',
  SCHLUESSELDIENST = 'SCHLUESSELDIENST',
}

export enum InsuranceActivationStatus {
  ACTIVATED = 'ACTIVATED',
  PENDING = 'PENDING',
  NOT_ACTIVATED = 'NOT_ACTIVATED',
}

export enum InsurancePackageType {
  PACKAGE_S = 'S',
  PACKAGE_M = 'M',
  PACKAGE_L = 'L',
}

export enum InsuranceUserSalutation {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  NEUTRAL = 'NEUTRAL',
}

export type InsurancePackageState = {
  status: InsuranceActivationStatus;
  type: InsurancePackageType;
  services: InsuranceServiceName[];
};

export interface InsuranceDetails {
  insuranceNumber: string;
  customerNumber: string;
  user?: {
    firstName: string;
    lastName: string;
    salutation?: InsuranceUserSalutation;
  };
  address?: {
    street: string;
    houseNumber: string;
    postalCode: string;
    city: string;
  };
  expirationDate?: number;
}

export interface UpdateInsuranceDetails {
  user?: {
    firstName: string;
    lastName: string;
    salutation?: InsuranceUserSalutation;
  };
  address?: {
    street: string;
    houseNumber: string;
    postalCode: string;
    city: string;
  };
}
